var map = {
	"./Back Upper Neck.jpg": 571,
	"./Back Upper.jpg": 572,
	"./Breast Left.jpg": 573,
	"./Breast Right.jpg": 574,
	"./Front Centre.jpg": 575,
	"./H'Wear Back Arch.jpg": 576,
	"./H'Wear Front Centre.jpg": 577,
	"./H'Wear Front Left.jpg": 578,
	"./H'Wear Front Right.jpg": 579,
	"./H'Wear Side Left.jpg": 580,
	"./H'Wear Side Right.jpg": 581,
	"./Leg Lower Left.jpg": 582,
	"./Leg Lower Right.jpg": 583,
	"./Leg Upper Left.jpg": 584,
	"./Leg Upper Right.jpg": 585,
	"./Sleeve Upper Left.jpg": 586,
	"./Sleeve Upper Right.jpg": 587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570;